export default __webpack_public_path__ + "static/media/business-ops.334f634b.webp";